import React from 'react'
import Slider from 'react-slick'

export default ({sliderSettings, trips}) => (
  <div className="trip-thumbnails">
    <Slider {...sliderSettings} className="trip-thumbnails__carousel carousel">
      {trips.map(trip => (
        <div key={trip.id} className="carousel__slide">
          <div className="carousel__holder">
            <img
              className="carousel__image"
              src={trip.acf.img_trip.url}
              alt={trip.acf.img_trip.alt}
            />
          </div>
        </div>
      ))}
    </Slider>
  </div>
)


// WEBPACK FOOTER //
// ./src/components/MainSlider/MainSlider.js